// Toggle debugging logs
const isDebug = false;
const baseStyles = [
  "color: #fff",
  "background-color: #2759e1",
  "padding: 2px 8px",
  "border-radius: 4px",
].join(";");
function consoleLog() {
  if (window.console && isDebug === true) {
    console.log("%cNP", baseStyles, ...Array.prototype.slice.call(arguments));
  }
}

/**
 * Sets up the form functionality.
 */
function initForm() {
  const listPacks = document.querySelectorAll(".package_col");
  const attrRegPrice = "data-price";
  const attrSubPrice = "data-subscription-price";

  /**
   * Adds an item to the cart.
   *
   * @param {string} variant_id - The Shopify ID of the variant to add to the cart.
   * @param {number} qty - The quantity of the variant to add to the cart.
   * @param {number} selling_plan - The StayAI selling plan ID (optional).
   * @returns {boolean} - Returns false.
   */
  const formATC = (variant_id, qty, selling_plan, listPack) => {
    consoleLog(["formATC", variant_id, qty, selling_plan]);
    data = {
      id: variant_id,
      quantity: qty,
    };
    if (selling_plan > 0) {
      data["selling_plan"] = selling_plan;
    }
    consoleLog(["data", data]);

    // const product = window.product;

    // fbq_data = {
    //   content_name: product.title,
    //   content_ids: product.id,
    //   content_type: "product_group",
    //   value: currentPrice.value,
    //   currency: product.currency,
    // };
    // consoleLog(["fbq_data", fbq_data]);
    // fbq("track", "AddToCart", fbq_data);
    // fbq("track", "InitiateCheckout", fbq_data);

    // make sure iCart is gone
    removeICart();

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        consoleLog('Waiting for iCart...');
        
        setTimeout(function () {
          consoleLog('Trying to get to checkout');
          listPack.querySelector(".package_button").classList.remove("processing");
          window.location.href = "/checkout?skipCache";
        }, 1000);
        return false;
      },
    });
  };

  /**
   * Adds a list pack to the cart.
   *
   * @param {HTMLElement} listPack - The list pack element to be added to the cart.
   */
  const addListPackToCart = (listPack) => {
    const currentVariant = listPack.getAttribute("data-id");

    let stayFrequency = 0;
    const isChecked = listPack.querySelector('input[type="checkbox"]').checked;
    if (isChecked) {
      stayFrequency =
        listPack.querySelector(".rtx-frequency").value ||
        listPack.querySelector(".rtx-frequency").options[0].value;
    }

    formATC(currentVariant, 1, stayFrequency, listPack);
  };

  /**
   * Initializes the Stay AI data by making an AJAX request to retrieve the product information.
   * If the product has selling plan groups and a specific selling plan group with app_id "5859381",
   * it populates the frequency options for the selling plans.
   * If the product does not have selling plan groups or the specific selling plan group is not found,
   * it hides the stay container.
   */
  const initStayAIData = () => {
    const productHandle = window.product.handle;
    $.getJSON(
      `${window.Shopify.routes.root}products/${productHandle}.js`,
      (product) => {
        const staySellingPlan = product.selling_plan_groups.find(
          (plan) => plan.app_id === "5859381"
        );
        if (product.selling_plan_groups.length < 0 && !staySellingPlan) {
          $(".stay-container").hide();
          return;
        }

        const sellingPlans = staySellingPlan.selling_plans;
        console.log(product);

        const sortedSellingPlans = sellingPlans.sort((a, b) => {
          const bPlanValue = b.options[0].value.toLowerCase();
          const bFrequency = bPlanValue.split(" ")[0];

          const aPlanValue = a.options[0].value.toLowerCase();
          const aFrequency = aPlanValue.split(" ")[0];

          if (aFrequency === bFrequency) return 0;
          return aFrequency < bFrequency ? -1 : 1;
        });

        // update subscription price (as we need exact one for currency purposes rather than calculating)
        product.variants.forEach((variant) => {
          const pack = variant.title.split(" ")[0];
          const listPack = document.querySelector(`.package_col[data-pack="${pack}"]`);

          if (!listPack || !variant?.selling_plan_allocations[0]?.price) return;

          const elRegPrice = listPack.querySelector(`.reg-price-${pack}`);
          const elYouSave = listPack.querySelector(`.you-save-price-${pack}`);
          const elSavePrice = listPack.querySelector(`.save-price-${pack}`);
          
          let comparePrice = elRegPrice.getAttribute(attrRegPrice);
          let subscriptionPrice = variant.selling_plan_allocations[0].price / 100;
          
          let isEu = false;
          if (comparePrice.includes(",")) {
            if (comparePrice.includes(".")) {
              comparePrice = comparePrice.replace(",", "");
            } else {
              isEu = true;
              comparePrice = comparePrice.replace(",", ".");
            }
          }

          let savePrice = (comparePrice - subscriptionPrice).toFixed(2).toString();
          subscriptionPrice = (subscriptionPrice).toFixed(2);

          if (isEu) {
            subscriptionPrice = subscriptionPrice.toString().replace(".", ",");
            comparePrice = comparePrice.replace(".", ",");
            savePrice = savePrice.replace(".", ",");
          }

          elYouSave.setAttribute('data-subscription-save', savePrice);
          elSavePrice.setAttribute(attrSubPrice, subscriptionPrice);

          consoleLog(["variant", variant, pack, subscriptionPrice, comparePrice]);

          updateOfferText(listPack);
        });

        sortedSellingPlans.forEach((plan) => {
          const planValue = plan.options[0].value.toLowerCase();
          const frequency = planValue.split(" ")[0];
          if (
            planValue.includes("week") ||
            (Number(frequency) && Number(frequency) > 3)
          )
            return;
          const option = document.createElement("option");
          option.setAttribute("data-frequency", frequency);
          option.value = plan.id;
          option.text = plan.name.replace("Delivery e", "E");
          option.text = plan.name.replace("month", "Month");
          $(".rtx-frequency").append(option);
        });
      }
    );
  };

  /**
   * Removes the iCart element
   */
  const removeICart = () => {
    $('body > .icart').remove();
  };

  /**
   * Updates the use case text based on the selected pack and frequency.
   * @param {HTMLElement} listPack - The list pack element.
   */
  const updateUseCase = (listPack) => {
    const vPacks = listPack.getAttribute("data-pack");
    const vValue = listPack.querySelector(".rtx-frequency").value;
    let vFrequency = listPack
      .querySelector(`option[value="${vValue}"]`);

    if (!vFrequency) return;

    vFrequency = vFrequency
      .getAttribute("data-frequency");
    consoleLog(["updateUseCase", vPacks, vFrequency]);

    var vFamilyUseText = "Perfect for everyday usage families with 2 children";
    if (vPacks == 1 || vPacks == 2 || vPacks == 3) {
      if (vFrequency == 1) {
        vFamilyUseText = "Perfect for everyday usage families with 2 children";
      } else if (vFrequency == 2) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      } else if (vFrequency == 3) {
        vFamilyUseText =
          "Perfect for use a few times a week by families with one child";
      }
    } else if (vPacks == 4) {
      if (vFrequency == 1) {
        vFamilyUseText =
          "Perfect for everyday use by families with three children";
      } else if (vFrequency == 2) {
        vFamilyUseText =
          "Perfect for everyday use by families with two or three children";
      } else if (vFrequency == 3) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      }
    }

    listPack.querySelector(".offer_text").innerText = vFamilyUseText;
  };

  /**
   * Updates the offer text based on the selected pack.
   *
   * @param {HTMLElement} listPack - The list pack element.
   */
  const updateOfferText = (listPack) => {
    consoleLog("updateOfferText", listPack);

    const pack = listPack.getAttribute("data-pack");
    const elSavePrice = listPack.querySelector(`.save-price-${pack}`);
    const elSavePercent = listPack.querySelector(`.save-percent-${pack}`);
    const elYouSave = listPack.querySelector(`.you-save-price-${pack}`);

    const regPriceFloat = listPack
      .querySelector(`.reg-price-${pack}`)
      .getAttribute(attrRegPrice);

    if (listPack.querySelector('input[type="checkbox"]').checked) {
      elSavePrice.innerText = elSavePrice.getAttribute(attrSubPrice);
      elSavePercent.innerText = elSavePercent.getAttribute(attrSubPrice);
      elYouSave.innerText = elYouSave.getAttribute('data-subscription-save');
    } else {
      elSavePrice.innerText = elSavePrice.getAttribute(attrRegPrice);
      elSavePercent.innerText = elSavePercent.getAttribute(attrRegPrice);
      elYouSave.innerText = elYouSave.getAttribute('data-save');
    }

    if (listPack.querySelector('input[type="checkbox"]').checked) {
      $(listPack).find(".offerBox").slideDown();

      updateUseCase(listPack);
    } else {
      $(listPack).find(".offerBox").slideUp();
    }
  };

  // add event listeners to each list pack
  listPacks.forEach((listPack) => {
    // listener to toggle StayAI
    const billingToggle = listPack
      .querySelector(".billingtoggle");
    if (billingToggle) {
      billingToggle.addEventListener("click", function () {
        updateOfferText(listPack);
      });
    }

    // listener to update use case
    listPack
      .querySelector(".rtx-frequency")
      .addEventListener("change", function () {
        updateUseCase(listPack);
      });

    // listener to ATC
    listPack
      .querySelector(".package_button")
      .addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        listPack.querySelector(".package_button").classList.add("processing");
        addListPackToCart(listPack);
        return false;
      });
  });

  initStayAIData();
}

/**
 * Initializes the benefit accordion functionality.
 * When a benefit heading is clicked, it toggles the visibility of the corresponding benefit content.
 */
function initBenefitAccordion() {
  $(".benefit-heading").click(function () {
    var questionDiv = $(this);
    var answerDiv = $(this).next(".benefit-content");
    var idx = $(".benefit-content").index(answerDiv);

    $(".benefit-content").each(function (index, ansDiv) {
      if (index != idx && $(ansDiv).is(":visible")) {
        $(ansDiv).slideUp(500, function () {
          $(ansDiv)
            .prev(".benefit-heading")
            .removeClass("benefit-heading-open");
        });
      }
    });

    if (answerDiv.is(":visible")) {
      answerDiv.stop().slideUp(500, function () {
        questionDiv.removeClass("benefit-heading-open");
      });
    } else {
      questionDiv.addClass("benefit-heading-open");
      answerDiv.stop().slideDown(500);
    }
  });
}

/**
 * Initializes the ACDNAccordion functionality.
 * This function sets up event listeners for the accordion headings and rows,
 * allowing them to expand and collapse when clicked.
 */
function initACDNAccordion() {
  $(".acdn-heading").click(function () {
    var questionDiv = $(this);
    var answerDiv = $(this).next(".acdn-content");
    var idx = $(".acdn-content").index(answerDiv);

    $(".acdn-content").each(function (index, ansDiv) {
      if (index != idx && $(ansDiv).is(":visible")) {
        $(ansDiv).slideUp(500, function () {
          $(ansDiv).prev(".acdn-heading").removeClass("accordion-open");
        });
      }
    });

    if (answerDiv.is(":visible")) {
      answerDiv.stop().slideUp(500, function () {
        questionDiv.removeClass("accordion-open");
      });
    } else {
      questionDiv.addClass("accordion-open");
      answerDiv.stop().slideDown(500);
    }
  });

  $(".acd_row_head").click(function (e) {
    var thisDiv = $(this).next(".acd_row_cont");
    if ($(thisDiv).is(":visible")) {
      $(this).next(".acd_row_cont").slideUp();
      $(this).removeClass("active");
    } else {
      $(".acd_row_cont").slideUp();
      $(this).next(".acd_row_cont").slideDown();
      $(".acd_row_head").removeClass("active");
      $(this).addClass("active");
    }
  });
}

/**
 * Initializes a countdown clock.
 * @param {string} id - The ID of the clock element.
 */
function initCountdown(id) {
  const getTimeRemaining = (endtime) => {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      total: t,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  };

  const updateClock = () => {
    var t = getTimeRemaining(endtime);

    // daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ("0" + t.hours).slice(-2);
    minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
    secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  };

  var deadline = new Date();
  // var deadline = new Date(Date.parse(new Date()) + 360 * 70 * 1000);
  deadline.setHours(deadline.getHours() + 6);
  deadline.setMinutes(deadline.getMinutes() + 35);
  const endtime = deadline;

  var clock = document.getElementById(id);
  // var daysSpan = clock.querySelector('.days');
  var hoursSpan = clock.querySelector(".hours");
  var minutesSpan = clock.querySelector(".minutes");
  var secondsSpan = clock.querySelector(".seconds");

  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}

/**
 * Initializes the mobile banner slick slider.
 */
function initMobileBannerSlick() {
  $(".bnr_slider").slick({
    dots: true,
    arrows: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  });
}

/**
 * Initializes the sticky header functionality.
 */
function initStickyHeader() {
  $(".topMenu").scroller();
  $(document).scroll(function () {
    if ($(this).scrollTop() > 110) {
      $(".top-fix-bar").addClass("fixed-nav");
    } else {
      $(".top-fix-bar").removeClass("fixed-nav");
    }

    if ($(this).scrollTop() > 10) {
      $(".mobilemenu").addClass("mobimenu-top");
    } else {
      $(".mobilemenu").removeClass("mobimenu-top");
    }
  });
}

/**
 * Initializes the dynamic packs on the page.
 */
function initDynamicPacks() {
  var dynamicPacksElements = document.querySelectorAll(".dynamic-packs");
  dynamicPacksElements.forEach(function (element) {
    var randomNumber = Math.floor(Math.random() * (250 - 150 + 1)) + 150;
    element.textContent = randomNumber;
  });
}

$(document).ready(function () {
  initForm();
  initBenefitAccordion();
  initACDNAccordion();
  initMobileBannerSlick();
  initStickyHeader();
  initCountdown("clockdiv2");
  initDynamicPacks();
});
